import { AppState } from '../root.reducer';

export const getCurrentModal = (state: AppState) => state.modal.currentModal;
